import {
  GET_INTEGRATION_SETTINGS, SET_INTEGRATION_SETTINGS, LOGOUT, GET_DESTINATION_REQUESTS, VALIDATE_SETTINGS, DELETE_CISCO_SETTINGS,
  UPDATE_BLOCK_REQUEST, GET_DESTINATION_LISTS, DELETE_DESTINATION_LIST, ADD_DESTINATION_LIST
} from '../types'
import moment from 'moment'

const initialState = {
  ciscoUmbrellaSettings: {
    summary: {
      settingID: '',
      accountID: '',
      organizationID: '',
      apiKey: '',
      apiSecret: '',
      createdBy: '',
      createdAt: 0,
      disabledBy: '',
      disabledAt: 0,
      enabled: false,
      enabledAt: 0,
      setupType: 'S'
    },
    units: {}
  },
  destinationLists: [],
  requests: [],
  restrictedDomains: [],
  unitDestinations: {},
  blockRequests: {
    approved: [],
    denied: [],
    pending: []
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_INTEGRATION_SETTINGS: return {
      ...state,
      ciscoUmbrellaSettings: action.payload.settings,
      unitDestinations: action.payload.unitDestinations,
      restrictedDomains: action.payload.restrictedDomains,
      blockRequests: action.payload.blockRequests
    }
    case SET_INTEGRATION_SETTINGS: return {
      ...state,
      ciscoUmbrellaSettings: {
        ...state.ciscoUmbrellaSettings,
        ...action.payload
      }
    }
    case GET_DESTINATION_REQUESTS: return {
      ...state,
      requests: action.payload
    }
    case VALIDATE_SETTINGS: return {
      ...state,
      destinationLists: action.payload
    }
    case UPDATE_BLOCK_REQUEST: return {
      ...state,
      blockRequests: {
        ...state.blockRequests,
        pending: [...state.blockRequests.pending, action.payload]
      }
    }
    case GET_DESTINATION_LISTS: return {
      ...state,
      destinationLists: action.payload
    }
    case ADD_DESTINATION_LIST: return {
      ...state,
      destinationLists: action.payload.destinationLists,
      ciscoUmbrellaSettings: {
        ...state.ciscoUmbrellaSettings,
        units: {
          ...state.ciscoUmbrellaSettings.units,
          ...action.payload.newMappings
        }
      }
    }
    case DELETE_DESTINATION_LIST: return {
      ...state,
      destinationLists: action.payload
    }
    case DELETE_CISCO_SETTINGS: return {
      ...state,
      ciscoUmbrellaSettings: {
        ...state.ciscoUmbrellaSettings,
        summary: {
          ...state.ciscoUmbrellaSettings.summary,
          enabled: false,
          // don't have access to auth to set current user as the deletor
          deletedAt: moment().unix()
        }
      }
    }
    case LOGOUT: return {
      ...state,
      ...initialState
    }
    default: return { ...state }
  }
}
